import { render, staticRenderFns } from "./WatchDogConfigurationForm.vue?vue&type=template&id=47a3127b&scoped=true"
import script from "./WatchDogConfigurationForm.vue?vue&type=script&setup=true&lang=js"
export * from "./WatchDogConfigurationForm.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a3127b",
  null
  
)

export default component.exports